import { useGetPromoEventData } from './useGetPromoEventData';

export const usePromoEventNeuronsModalDescription = () => {
	const { isResolved, data } = useGetPromoEventData();
	const neuronsOffer = data?.offers.find((offer) => offer.type === 'Neurons');
	const title = neuronsOffer?.paywallHeaderText;
	const subtitle = neuronsOffer?.paywallSubtitleText;
	const promocode = neuronsOffer?.promoCode;
	let descriptionTextTemplate = neuronsOffer?.paywallDescriptionTextTemplate;
	if (data?.endDate) {
		const endDate = new Date(data.endDate);
		const formattedData = new Intl.DateTimeFormat('en-US', {
			day: 'numeric',
			month: 'long',
			timeZone: 'UTC',
		}).format(endDate);
		descriptionTextTemplate = descriptionTextTemplate?.replace(
			'{endDate}',
			formattedData
		);
	}
	if (promocode) {
		descriptionTextTemplate = descriptionTextTemplate?.replace(
			'{promocode}',
			promocode
		);
	}
	return { isResolved, title, subtitle, description: descriptionTextTemplate };
};
